import * as React from 'react';
import { Input, Select, Checkbox, Row, Col } from 'antd';
import { FormItem } from '../../../../components/Form';
import PriceInput from '../../../../components/Others/PriceInput';

export interface IGeneralSettingsColProps {
  voucherGroup: GQL.IVoucherGroup;
  onChange: Function;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps> {

  public render() {
    const { voucherGroup } = this.props;

    return (
      <div>
        <FormItem label={'Title'} required={true}>
          <Input
            name={'title'}
            autoFocus={true}
            required={true}
            placeholder="Internal title"
            addonBefore={'Internal'}
            defaultValue={voucherGroup.title}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Source'} required={true}>
          <Select
            style={{ width: '100%' }}
            placeholder="Select source"
            value={voucherGroup.source || 'price'}
            onChange={(value: string) => this.props.onChange({ target: { name: 'source', value } })}
          >
            <Select.Option key={'recommendedPrice'} value={'recommended'}>
              Recommended Price
            </Select.Option>
            <Select.Option key={'price'} value={'price'}>
              Price
            </Select.Option>
          </Select>
        </FormItem>
        <FormItem>
          <Checkbox
            name={'applyToDiscountedGoods'}
            checked={voucherGroup.applyToDiscountedGoods !== null && voucherGroup.applyToDiscountedGoods !== undefined ? voucherGroup.applyToDiscountedGoods : false}
            onChange={e => this.props.onChange(e)}
          >
            Apply vouchers to discounted goods
          </Checkbox>
        </FormItem>
        <FormItem label={'Type'} required={true}>
          <Select
            style={{ width: '100%' }}
            placeholder="Select type"
            value={voucherGroup.type || 'percent'}
            onChange={(value: string) => this.props.onChange({ target: { name: 'type', value } })}
          >
            <Select.Option key={'amount'} value={'amount'}>
              Amount
            </Select.Option>
            <Select.Option key={'percent'} value={'percent'}>
              Percentage
            </Select.Option>
          </Select>
        </FormItem>
        <FormItem label={'Amount'} required={true}>
          <Input
            type={'number'}
            name={'amount'}
            required={true}
            value={voucherGroup.amount}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <Row gutter={15}>
          <Col span={12}>
            <FormItem label={'Min. price of single item (excl. VAT)'}>
              <PriceInput
                name={'minimumPricesOfSingleItem'}
                mode={'priceWithout'}
                prices={voucherGroup.minimumPricesOfSingleItem || []}
                onChange={this.props.onChange}
              />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label={'Max. price of single item (excl. VAT)'}>
              <PriceInput
                name={'maximumPricesOfSingleItem'}
                mode={'priceWithout'}
                prices={voucherGroup.maximumPricesOfSingleItem || []}
                onChange={this.props.onChange}
              />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={15}>
          <Col span={12}>
            <FormItem label={'Min. order total (excl. VAT)'}>
              <PriceInput
                name={'minimumPricesOfOrder'}
                mode={'priceWithout'}
                prices={voucherGroup.minimumPricesOfOrder || []}
                onChange={this.props.onChange}
              />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label={'Max. order total (excl. VAT)'}>
              <PriceInput
                mode={'priceWithout'}
                name={'maximumPricesOfOrder'}
                prices={voucherGroup.maximumPricesOfOrder || []}
                onChange={this.props.onChange}
              />
            </FormItem>
          </Col>
        </Row>
        <FormItem>
          <Checkbox
            name={'active'}
            checked={voucherGroup.active !== null && voucherGroup.active !== undefined ? voucherGroup.active : true}
            onChange={e => this.props.onChange(e)}
          >
            Active
          </Checkbox>
        </FormItem>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticVoucherGroups/VoucherGroupDetail/components/General.tsx